import { LoudnessPreset } from "../../model/Mastering";

const loudnessPresetMapping: Record<
    LoudnessPreset,
    { label: string; hint: string; lufs: number }
> = {
    LOW: {
        label: "Standard",
        hint: "Perfect for all streaming platforms. Required by services like Amazon Music, Tidal, and YouTube.",
        lufs: -14,
    },
    MEDIUM: {
        label: "Medium",
        hint: "Boosts loudness for louder streaming services like Spotify Loud.",
        lufs: -11,
    },
    HIGH: {
        label: "Loud",
        hint: "Matches chart volume but reduces dynamics.",
        lufs: -8,
    },
};

export default loudnessPresetMapping;
